import { createBrowserRouter, Navigate } from 'react-router-dom';
import { EmptyLayout, MainLayout } from './components/layout/Layout';
import { LoginPage } from './pages/LoginPage';
import { FeederPage } from './pages/FeederPage';
import { NotFound } from './pages/ErrorPage';
import { AuthService } from './components/service/AuthService';
import { showToast } from './components/utils/Toastify';
import { AdminMenuSettingPage } from './pages/AdminMenuSettingPage';
import { AdminMenuAssignPage } from './pages/AdminMenuAssignPage';

const AuthRouter = ({ children }) => {
    if(!AuthService.isLoggedIn()){
        showToast.error("권한이 없습니다.");
        return <Navigate to="/auth/login" replace />;
    }
    return children;
}

const router = createBrowserRouter([
    {
        element: <EmptyLayout />,
        children: [
            { path: '/auth/login', element: <LoginPage /> }
        ]
    },
    {
        element: <MainLayout />,
        children: [
            { path: '/manage/feeder', element: <AuthRouter><FeederPage/></AuthRouter> },
            { path: '/admin/menu/setting', element: <AdminMenuSettingPage/> },
            { path: '/admin/menu/assign', element: <AdminMenuAssignPage/> },
        ]
    },
    {
        path : '/', 
        element: <Navigate to="/manage/feeder" replace /> // BaseUrl 설정
    },
    {
        path: '*',
        element: <NotFound />,
    }
]);



export default router;